export function formatDiagnostics(diagnostics, file, hints) {
    const lines = diagnostics.map((diagnostic) => {
        const loc = diagnostic.span === undefined
            ? ''
            : `${file !== null && file !== void 0 ? file : '<input>'}:${diagnostic.span.line}:${diagnostic.span.column}: `;
        return `${loc}${diagnostic.severity} ${diagnostic.code}: ${diagnostic.message}`;
    });
    for (const hint of hints !== null && hints !== void 0 ? hints : []) {
        if (hint.length > 0)
            lines.push(hint);
    }
    return lines.join('\n');
}
